module.exports = __webpack_public_path__ + "img/dialogBg.317ea807.png";